import { render, staticRenderFns } from "./FeaturedCalendarItem.vue?vue&type=template&id=9a8404d4&scoped=true&"
import script from "./FeaturedCalendarItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedCalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCalendarItem.vue?vue&type=style&index=0&id=9a8404d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8404d4",
  null
  
)

export default component.exports